var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSponaLogoLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 475,
    height: 475,
    viewBox: "0 0 475 475",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_16277_140824)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 49,
    width: 328,
    height: 328,
    rx: 164,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.887 114.602C185.111 114.602 143.891 151.211 143.891 196.716C143.891 249.235 190.808 276.778 235.546 276.778C260.68 276.778 285.647 261.723 285.647 239.826C285.647 192.953 216.109 215.705 216.109 187.649C216.109 178.925 225.325 173.279 237.389 173.279C250.627 173.279 260.178 180.464 261.518 190.044H283.636C280.788 167.292 260.848 154.461 237.892 154.461C212.088 154.461 194.662 169.174 194.662 189.36C194.662 212.626 212.926 218.1 230.855 221.522C247.778 224.772 264.199 226.14 264.199 240.339C264.199 250.262 249.789 257.447 235.379 257.447C202.872 257.447 164.333 235.892 164.333 196.032C164.333 161.304 195.667 133.933 236.887 133.933C281.458 133.933 317.819 171.055 317.819 216.56C317.819 262.066 281.458 299.188 236.887 299.188C202.202 299.188 178.743 282.594 168.019 272.672L156.123 287.897C178.408 308.255 206.391 318.69 236.887 318.69C292.014 318.69 338.261 273.014 338.261 216.732C338.261 160.449 292.014 114.602 236.887 114.602Z",
    fill: "#6D51F6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_16277_140824",
    x: 0.540744,
    y: 0.40741,
    width: 473.778,
    height: 473.778,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.42963,
    dy: 24.2963
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 36.4444
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.219608 0 0 0 0 0.270588 0 0 0 0 0.447059 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16277_140824"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16277_140824",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSponaLogoLight);
export default __webpack_public_path__ + "static/media/spona-logo-light.25d7c4fb73d3b66dab1e8168fff670d3.svg";
export { ForwardRef as ReactComponent };